/**
 * 【KYMW1407】使用履歴一覧取得VO
 *
 * @export GetUseRecordImageListModel
 * @class GetUseRecordImageListModel
 */
export class GetUseRecordImageListModel {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** 生協コード */
  public coopCode = String('');
  /** Ｐコード  */
  public pcode = String('');
  /** 今回受注コード */
  public thisOrderCode = String('');
}
